import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { environment } from './env/environment';
import { BUILD_INFO } from './build-info';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

if (environment.sentry.dsn) {
  // Sentry.init({
  //   dsn: `https://${environment.sentry.dsn}.ingest.de.sentry.io/${environment.sentry.projectId}`,
  //   sendDefaultPii: true,
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration(),
  //     Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
  //   ],
  //   // Tracing
  //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  //   // Enable sending logs to Sentry
  //   enableLogs: true
  // });
}

console.log(`%c Letly`, 'background: #3378FF; color: white; font-size: 25px; font-weight: bold; padding: 25px 40%;');
console.log('v' + BUILD_INFO.version + ' ------------------------------------  ' + 'build at: ' + BUILD_INFO.buildDate);

if (!environment.appMetadata['prod']) {
  console.table(BUILD_INFO);
}

if (Capacitor.isNativePlatform()) {
  void SplashScreen.hide({ fadeOutDuration: 300 });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
